import { protectedApi } from "./protectedApi";
import { APIS } from "../constants/apiConstant";

export async function sendDailyHoursViewEmail(metadata) {
  const response = await protectedApi({
    url: APIS.DAILY_HOURS_SEND_VIEW_EMAIL,
    method: "POST",
    data: metadata,
  });
  return response?.data;
}
